
const parseJpeg = {
    testff() {
        console.log("ffdf");
    },
    
    parse(data) {
        try {
        var offset = 0, length = data.length;
        function readUint16() {
          var value = (data[offset] << 8) | data[offset + 1];
          offset += 2;
          return value;
        }
        function readDataBlock() {
          var length = readUint16();
          var array = data.subarray(offset, offset + length - 2);
          offset += array.length;
          return array;
        }
        function prepareComponents(frame) {
          var maxH = 0, maxV = 0;
          var component, componentId;
          for (componentId in frame.components) {
            if (frame.components.hasOwnProperty(componentId)) {
              component = frame.components[componentId];
              if (maxH < component.h) maxH = component.h;
              if (maxV < component.v) maxV = component.v;
            }
          }
          var mcusPerLine = Math.ceil(frame.samplesPerLine / 8 / maxH);
          var mcusPerColumn = Math.ceil(frame.scanLines / 8 / maxV);
          for (componentId in frame.components) {
            if (frame.components.hasOwnProperty(componentId)) {
              component = frame.components[componentId];
              var blocksPerLine = Math.ceil(Math.ceil(frame.samplesPerLine / 8) * component.h / maxH);
              var blocksPerColumn = Math.ceil(Math.ceil(frame.scanLines  / 8) * component.v / maxV);
              var blocksPerLineForMcu = mcusPerLine * component.h;
              var blocksPerColumnForMcu = mcusPerColumn * component.v;
              var blocksToAllocate = blocksPerColumnForMcu * blocksPerLineForMcu;
              var blocks = [];
    
              // Each block is a Int32Array of length 64 (4 x 64 = 256 bytes)
              requestMemoryAllocation(blocksToAllocate * 256);
    
              for (var i = 0; i < blocksPerColumnForMcu; i++) {
                var row = [];
                for (var j = 0; j < blocksPerLineForMcu; j++)
                  row.push(new Int32Array(64));
                blocks.push(row);
              }
              component.blocksPerLine = blocksPerLine;
              component.blocksPerColumn = blocksPerColumn;
              component.blocks = blocks;
            }
          }
          frame.maxH = maxH;
          frame.maxV = maxV;
          frame.mcusPerLine = mcusPerLine;
          frame.mcusPerColumn = mcusPerColumn;
        }
        var jfif = null;
        var adobe = null;
        var pixels = null;
        var frame, resetInterval;
        var quantizationTables = [], frames = [];
        var huffmanTablesAC = [], huffmanTablesDC = [];
        var fileMarker = readUint16();
        var malformedDataOffset = -1;
        this.comments = [];
        if (fileMarker != 0xFFD8) { // SOI (Start of Image)
          throw new Error("SOI not found");
        }
    
        fileMarker = readUint16();
        while (fileMarker != 0xFFD9 && offset < data.length) { // EOI (End of image)
          var i, j, l;
          switch(fileMarker) {
            case 0xFF00: break;
            case 0xFFE0: // APP0 (Application Specific)
            case 0xFFE1: // APP1
            case 0xFFE2: // APP2
            case 0xFFE3: // APP3
            case 0xFFE4: // APP4
            case 0xFFE5: // APP5
            case 0xFFE6: // APP6
            case 0xFFE7: // APP7
            case 0xFFE8: // APP8
            case 0xFFE9: // APP9
            case 0xFFEA: // APP10
            case 0xFFEB: // APP11
            case 0xFFEC: // APP12
            case 0xFFED: // APP13
            case 0xFFEE: // APP14
            case 0xFFEF: // APP15
            case 0xFFFE: // COM (Comment)
              var appData = readDataBlock();
    
              //if (fileMarker === 0xFFFE) {
              //  var comment = String.fromCharCode.apply(null, appData);
              //  this.comments.push(comment);
              //}
    
              // if (fileMarker === 0xFFE0) {
              //   if (appData[0] === 0x4A && appData[1] === 0x46 && appData[2] === 0x49 &&
              //     appData[3] === 0x46 && appData[4] === 0) { // 'JFIF\x00'
              //     jfif = {
              //       version: { major: appData[5], minor: appData[6] },
              //       densityUnits: appData[7],
              //       xDensity: (appData[8] << 8) | appData[9],
              //       yDensity: (appData[10] << 8) | appData[11],
              //       thumbWidth: appData[12],
              //       thumbHeight: appData[13],
              //       thumbData: appData.subarray(14, 14 + 3 * appData[12] * appData[13])
              //     };
              //   }
              // }
              // TODO APP1 - Exif
              // if (fileMarker === 0xFFE1) {
              //   if (appData[0] === 0x45 &&
              //     appData[1] === 0x78 &&
              //     appData[2] === 0x69 &&
              //     appData[3] === 0x66 &&
              //     appData[4] === 0) { // 'EXIF\x00'
              //     this.exifBuffer = appData.subarray(5, appData.length);
              //   }
              // }
    
              // if (fileMarker === 0xFFEE) {
              //   if (appData[0] === 0x41 && appData[1] === 0x64 && appData[2] === 0x6F &&
              //     appData[3] === 0x62 && appData[4] === 0x65 && appData[5] === 0) { // 'Adobe\x00'
              //     adobe = {
              //       version: appData[6],
              //       flags0: (appData[7] << 8) | appData[8],
              //       flags1: (appData[9] << 8) | appData[10],
              //       transformCode: appData[11]
              //     };
              //   }
              // }
              break;
    
            // case 0xFFDB: // DQT (Define Quantization Tables)
            //   offset+=readUint16();
            //   // var quantizationTablesLength = readUint16();
            //   // var quantizationTablesEnd = quantizationTablesLength + offset - 2;
            //   // while (offset < quantizationTablesEnd) {
            //   //   var quantizationTableSpec = data[offset++];
            //   //   requestMemoryAllocation(64 * 4);
            //   //   var tableData = new Int32Array(64);
            //   //   if ((quantizationTableSpec >> 4) === 0) { // 8 bit values
            //   //     for (j = 0; j < 64; j++) {
            //   //       var z = dctZigZag[j];
            //   //       tableData[z] = data[offset++];
            //   //     }
            //   //   } else if ((quantizationTableSpec >> 4) === 1) { //16 bit
            //   //     for (j = 0; j < 64; j++) {
            //   //       var z = dctZigZag[j];
            //   //       tableData[z] = readUint16();
            //   //     }
            //   //   } else
            //   //     throw new Error("DQT: invalid table spec");
            //   //   quantizationTables[quantizationTableSpec & 15] = tableData;
            //   // }
            //   break;
    
            case 0xFFC0: // SOF0 (Start of Frame, Baseline DCT)
            case 0xFFC1: // SOF1 (Start of Frame, Extended DCT)
            case 0xFFC2: // SOF2 (Start of Frame, Progressive DCT)
              readUint16(); // skip data length
              frame = {};
              frame.extended = (fileMarker === 0xFFC1);
              frame.progressive = (fileMarker === 0xFFC2);
              frame.precision = data[offset++];
              frame.scanLines = readUint16();
              frame.samplesPerLine = readUint16();
              frame.components = {};
              frame.componentsOrder = [];
              fileMarker = 0xFFD9;
              continue;
              break;
              // var pixelsInFrame = frame.scanLines * frame.samplesPerLine;
              // if (pixelsInFrame > maxResolutionInPixels) {
              //   var exceededAmount = Math.ceil((pixelsInFrame - maxResolutionInPixels) / 1e6);
              //   throw new Error(`maxResolutionInMP limit exceeded by ${exceededAmount}MP`);
              // }
    
              // var componentsCount = data[offset++], componentId;
              // var maxH = 0, maxV = 0;
              // for (i = 0; i < componentsCount; i++) {
              //   componentId = data[offset];
              //   var h = data[offset + 1] >> 4;
              //   var v = data[offset + 1] & 15;
              //   var qId = data[offset + 2];
              //   frame.componentsOrder.push(componentId);
              //   frame.components[componentId] = {
              //     h: h,
              //     v: v,
              //     quantizationIdx: qId
              //   };
              //   offset += 3;
              // }
              // prepareComponents(frame);
              // frames.push(frame);
    
              break;
    
            // case 0xFFC4: // DHT (Define Huffman Tables)
            //   var huffmanLength = readUint16();
            //   for (i = 2; i < huffmanLength;) {
            //     var huffmanTableSpec = data[offset++];
            //     var codeLengths = new Uint8Array(16);
            //     var codeLengthSum = 0;
            //     for (j = 0; j < 16; j++, offset++) {
            //       codeLengthSum += (codeLengths[j] = data[offset]);
            //     }
            //     requestMemoryAllocation(16 + codeLengthSum);
            //     var huffmanValues = new Uint8Array(codeLengthSum);
            //     for (j = 0; j < codeLengthSum; j++, offset++)
            //       huffmanValues[j] = data[offset];
            //     i += 17 + codeLengthSum;
    
            //     ((huffmanTableSpec >> 4) === 0 ?
            //       huffmanTablesDC : huffmanTablesAC)[huffmanTableSpec & 15] =
            //       buildHuffmanTable(codeLengths, huffmanValues);
            //   }
            //   break;
    
            // case 0xFFDD: // DRI (Define Restart Interval)
            //   readUint16(); // skip data length
            //   resetInterval = readUint16();
            //   break;
    
            // case 0xFFDC: // Number of Lines marker
            //   readUint16() // skip data length
            //   readUint16() // Ignore this data since it represents the image height
            //   break;
              
            // case 0xFFDA: // SOS (Start of Scan)
            //   var scanLength = readUint16();
            //   var selectorsCount = data[offset++];
            //   var components = [], component;
            //   for (i = 0; i < selectorsCount; i++) {
            //     component = frame.components[data[offset++]];
            //     var tableSpec = data[offset++];
            //     component.huffmanTableDC = huffmanTablesDC[tableSpec >> 4];
            //     component.huffmanTableAC = huffmanTablesAC[tableSpec & 15];
            //     components.push(component);
            //   }
            //   var spectralStart = data[offset++];
            //   var spectralEnd = data[offset++];
            //   var successiveApproximation = data[offset++];
            //   var processed = decodeScan(data, offset,
            //     frame, components, resetInterval,
            //     spectralStart, spectralEnd,
            //     successiveApproximation >> 4, successiveApproximation & 15, this.opts);
            //   offset += processed;
            //   break;
    
            case 0xFFFF: // Fill bytes
              if (data[offset] !== 0xFF) { // Avoid skipping a valid marker.
                offset--;
              }
              break;
            default:
              if (data[offset - 3] == 0xFF &&
                  data[offset - 2] >= 0xC0 && data[offset - 2] <= 0xFE) {
                // could be incorrect encoding -- last 0xFF byte of the previous
                // block was eaten by the encoder
                offset -= 3;
                break;
              }
              else if (fileMarker === 0xE0 || fileMarker == 0xE1) {
                // Recover from malformed APP1 markers popular in some phone models.
                // See https://github.com/eugeneware/jpeg-js/issues/82
                if (malformedDataOffset !== -1) {
                  throw new Error(`first unknown JPEG marker at offset ${malformedDataOffset.toString(16)}, second unknown JPEG marker ${fileMarker.toString(16)} at offset ${(offset - 1).toString(16)}`);
                }
                malformedDataOffset = offset - 1;
                const nextOffset = readUint16();
                if (data[offset + nextOffset - 2] === 0xFF) {
                  offset += nextOffset - 2;
                  break;
                }
              }
              else
              {
                offset+=readUint16();
                // const nextOffset = readUint16();
                // if (data[offset + nextOffset - 2] === 0xFF) {
                //   offset += nextOffset - 2;
                //   break;
                // }
              }
    
              //throw new Error("unknown JPEG marker " + fileMarker.toString(16));
          }
          fileMarker = readUint16();
        }
        if (frame === undefined){
            return undefined;
        }
        this.width = frame.samplesPerLine;
        this.height = frame.scanLines;
        this.jfif = jfif;
        this.adobe = adobe;
        this.components = [];

        return this;
    }
    catch(err) {
        console.log('parseJpeg error ' + err);
    }
      }
}

var totalBytesAllocated = 0;
var maxMemoryUsageBytes = 0;
function requestMemoryAllocation(increaseAmount = 0) {
    var totalMemoryImpactBytes = totalBytesAllocated + increaseAmount;
    if (totalMemoryImpactBytes > maxMemoryUsageBytes) {
      var exceededAmount = Math.ceil((totalMemoryImpactBytes - maxMemoryUsageBytes) / 1024 / 1024);
      throw new Error(`maxMemoryUsageInMB limit exceeded by at least ${exceededAmount}MB`);
    }

    totalBytesAllocated = totalMemoryImpactBytes;
  }

export { parseJpeg as default }
